import { TravelerRole } from '~/models/Traveler'
import { TRIP_INVITATION_STATUS, TripInvitation } from '~/models/TripInvitation'
import { InvitationRepository } from './repository'

export class InvitationService {
	public static async generateInvitationCode(
		itineraryId: string,
		role?: TravelerRole
	): Promise<TripInvitation> {
		return await InvitationRepository.generateInvitation(itineraryId, role)
	}

	public static async inviteWithEmail(itineraryId: string, email: string): Promise<TripInvitation> {
		const role: TravelerRole = 'manager'
		return await InvitationRepository.generateInvitation(itineraryId, role, email)
	}

	public static async acceptInvitation(itineraryId: string, code: string): Promise<void> {
		return await InvitationRepository.acceptInvitation(itineraryId, code)
	}

	public static async getInvitations(itineraryId: string): Promise<TripInvitation[]> {
		return await InvitationRepository.getInvitations(itineraryId)
	}

	public static async cancelInvitation(
		itineraryId: string,
		invitationId: string
	): Promise<TripInvitation> {
		const status = TRIP_INVITATION_STATUS.CANCELLED
		return await InvitationRepository.updateInvitation(itineraryId, invitationId, status)
	}
}
